<script lang="ts">
	import { locale, t } from '$lib/translations';

	import Elsewhere from './Elsewhere.svelte';

	let CURRENT_YEAR = $derived(new Date().getFullYear());
</script>

<div class="bg-bridal-heath-50 rounded-b-md mx-2 shadow-xl shadow-white/10 border-t border-light-gray">
	<div class="px-2 md:px-4 lg:px-8 pt-12 pb-8">
		<div class="mx-auto max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-8">
			<div id="newsletter">
				<h3 class="font-sans uppercase border-b-4 inline-block px-2 md:px-4 lg:px-8">Newsletter</h3>
				<div class="border-t px-2 md:px-4 lg:px-8 py-4 bg-princeton-orange">
					<form
						action="//sistrall.us1.list-manage.com/subscribe/post?u=be56c28b85bd44522ac00eebd&id=98dcf01912"
						class="validate"
						id="mc-embedded-subscribe-form"
						method="post"
						name="mc-embedded-subscribe-form"
						novalidate={true}
						target="_blank"
					>
						<fieldset>
							<div style="position: absolute; left: -5000px;">
								<input name="b_be56c28b85bd44522ac00eebd_98dcf01912" type="text" value="" />
							</div>
							<p>
								{$t('shared.insertYourEmailAddress')}
								No spam, I promise. —
								<em>Powered by <a rel="nofollow" href="https://mailchimp.com" title="MailChimp - Email marketing made easy and fun">MailChimp</a></em>
							</p>
							<div class="flex gap-4 mt-4">
								<input
									class="required email flex-auto border border-light-gray p-2 bg-bridal-heath-50"
									id="mce-EMAIL"
									name="EMAIL"
									placeholder="Email"
									type="email"
									value=""
								/>
								<input
									class="button bg-sage-green text-sapphire rounded-sm px-4"
									id="mc-embedded-subscribe"
									name="subscribe"
									type="submit"
									value={$t('shared.send')}
								/>
							</div>
						</fieldset>
					</form>
				</div>
			</div>
			<div>
				<h3 class="font-sans uppercase border-b-4 inline-block px-2 md:px-4 lg:px-8">
					<span class="bg-blue-500 px-2 inline-block">{$t('shared.meElsewhere')}</span>
				</h3>
				<div class="border-t px-2 md:px-4 lg:px-8 py-4">
					<Elsewhere />
				</div>
			</div>
		</div>
	</div>
</div>

<div class="text-sage-green">
	<div class="px-2 md:px-4 lg:px-8 mx-auto p-8 grid [&>p]:text-center gap-2 md:gap-4">
		<p>
			{#if $locale === 'it'}
				Sono Silvano Stralla. Faccio lo sviluppatore, mi piace fare fotografie e pedalare biciclette.<br />Se vuoi, puoi scrivermi a silvano.stralla at
				sistrall.it.<br />Questo sito è fatto a mano, con amore, a Torino (Italia).
			{/if}
			{#if $locale === 'en'}
				I am Silvano Stralla. I am a developer, I like taking photos and riding bikes. <br />If you want, you can write to me at silvano.stralla at sistrall.it.
				<br />This site is handmade, with love, in Turin (Italy).
			{/if}
		</p>
		<p>
			© 2002—{CURRENT_YEAR} Silvano Stralla
		</p>
		<p>
			<a href="#page-header">
				{#if $locale === 'it'}
					Torna su
				{/if}
				{#if $locale === 'en'}
					To the top
				{/if}
				{' '}↑
			</a>
		</p>
	</div>
</div>
